import Typography from '@mui/material/Typography';
import { usePatientOfflineStatus } from '../hooks/usePatientOfflineStatus';
import { OFFLINE_STATUS } from '../../services/offlineService';

/** @param {{ patientId: string }} props */
export default function OfflineStatusCell({ patientId }) {
  const { offlineStatus } = usePatientOfflineStatus(patientId);

  if (offlineStatus === OFFLINE_STATUS.READY) {
    return (
      <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 600 }}>
        Offline Available
      </Typography>
    );
  }

  if (offlineStatus === OFFLINE_STATUS.DOWNLOADING) {
    return (
      <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600 }}>
        Downloading...
      </Typography>
    );
  }

  return (
    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
      Online Only
    </Typography>
  );
}
